import React, { FC, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Verify } from "./Verify";
import { useLoginMutation } from "../../store/services/auth";
import { ROUTES } from "../../routes";
import { useTriggerToastOnRTKError } from "../../hooks/useTriggerToastOnRTKError";

type Inputs = {
  code?: string;
};

export const VerifyPage: FC = () => {
  const location = useLocation();
  const {
    state: { form, ...restLocationState },
  } = location;
  const navigate = useNavigate();

  const [login, { isSuccess, isError, error }] = useLoginMutation();

  useTriggerToastOnRTKError(isError, error);

  const action = async (params: Inputs) => {
    await login({
      ...form,
      ...params,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      navigate(ROUTES.HOME, { state: { ...restLocationState } });
    }
  }, [isSuccess, navigate, restLocationState]);

  return <Verify action={action} />;
};
